import { render, staticRenderFns } from "./StatsRestrictedSoonAccounts.vue?vue&type=template&id=4f1903b6&"
import script from "./StatsRestrictedSoonAccounts.vue?vue&type=script&lang=js&"
export * from "./StatsRestrictedSoonAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports